// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicBusStopControllerFindTariffZoneData } from './PublicBusStopControllerFindTariffZoneData.gen';
import type { PublicBusStopControllerFindTariffZoneErrors } from './PublicBusStopControllerFindTariffZoneErrors.gen';
import type { PublicBusStopControllerFindTariffZoneResponses } from './PublicBusStopControllerFindTariffZoneResponses.gen';
import type { PublicBusStopControllerGetAllData } from './PublicBusStopControllerGetAllData.gen';
import type { PublicBusStopControllerGetAllErrors } from './PublicBusStopControllerGetAllErrors.gen';
import type { PublicBusStopControllerGetAllResponses } from './PublicBusStopControllerGetAllResponses.gen';
import type { PublicBusStopControllerPermittedSaleCheckData } from './PublicBusStopControllerPermittedSaleCheckData.gen';
import type { PublicBusStopControllerPermittedSaleCheckErrors } from './PublicBusStopControllerPermittedSaleCheckErrors.gen';
import type { PublicBusStopControllerPermittedSaleCheckResponses } from './PublicBusStopControllerPermittedSaleCheckResponses.gen';

export class PublicBusStopController {
    /**
     * Get bus stops.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicBusStopControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicBusStopControllerGetAllResponses, PublicBusStopControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/bus-stops',
            ...options
        });
    }
    
    /**
     * Check if bus stop combination is valid
     */
    public static permittedSaleCheck<ThrowOnError extends boolean = false>(options: Options<PublicBusStopControllerPermittedSaleCheckData, ThrowOnError>) {
        return (options.client ?? client).get<PublicBusStopControllerPermittedSaleCheckResponses, PublicBusStopControllerPermittedSaleCheckErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/bus-stops/permitted-sale-check',
            ...options
        });
    }
    
    /**
     * Check if bus stop combination is valid, if so, return ticket type and note
     */
    public static findTariffZone<ThrowOnError extends boolean = false>(options: Options<PublicBusStopControllerFindTariffZoneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicBusStopControllerFindTariffZoneResponses, PublicBusStopControllerFindTariffZoneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/bus-stops/find-tariff-zone',
            ...options
        });
    }
}
